// ============================================================
// MA BOUTIQUE — Theme JS
// ============================================================

document.addEventListener('DOMContentLoaded', function () {

  // --- MEGA MENU AU SURVOL ---
  var header = document.getElementById('site-header');
  var overlay = document.getElementById('mega-overlay');
  var currentMega = null;
  var closeTimer = null;

  function openMega(handle) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (currentMega === handle) return;
    closeMega(true);
    currentMega = handle;
    var menu = document.getElementById('mega-' + handle);
    var navItem = document.querySelector('[data-nav-handle="' + handle + '"]');
    if (menu) menu.classList.add('is-open');
    if (navItem) navItem.classList.add('is-active');
    if (overlay) overlay.classList.add('is-visible');
  }

  function closeMega(immediate) {
    if (!currentMega) return;
    var menu = document.getElementById('mega-' + currentMega);
    var navItem = document.querySelector('[data-nav-handle="' + currentMega + '"]');
    if (menu) menu.classList.remove('is-open');
    if (navItem) navItem.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-visible');
    currentMega = null;
  }

  // Attacher les événements hover sur chaque nav-item
  document.querySelectorAll('.nav-item--has-mega').forEach(function(item) {
    var handle = item.getAttribute('data-nav-handle');

    item.addEventListener('mouseenter', function() {
      openMega(handle);
    });
    item.addEventListener('mouseleave', function() {
      closeTimer = setTimeout(closeMega, 120);
    });

    // Le mega menu lui-même
    var mega = document.getElementById('mega-' + handle);
    if (mega) {
      mega.addEventListener('mouseenter', function() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      mega.addEventListener('mouseleave', function() {
        closeTimer = setTimeout(closeMega, 120);
      });
    }
  });

  // Items sans mega : fermer si on passe dessus
  document.querySelectorAll('.nav-item:not(.nav-item--has-mega)').forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      closeMega();
    });
  });

  // Overlay click ferme
  if (overlay) overlay.addEventListener('click', closeMega);

  // --- SEARCH OVERLAY ---
  var searchOverlay = document.getElementById('search-overlay');
  document.querySelectorAll('[data-open-search]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (searchOverlay) {
        searchOverlay.classList.add('is-open');
        setTimeout(function() {
          var inp = searchOverlay.querySelector('input');
          if (inp) inp.focus();
        }, 100);
      }
    });
  });
  document.querySelectorAll('[data-close-search]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (searchOverlay) searchOverlay.classList.remove('is-open');
    });
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (searchOverlay) searchOverlay.classList.remove('is-open');
      closeMega();
    }
  });

  // --- CART DRAWER ---
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
  }
  document.querySelectorAll('[data-open-cart]').forEach(function(btn) {
    btn.addEventListener('click', openCart);
  });
  document.querySelectorAll('[data-close-cart]').forEach(function(btn) {
    btn.addEventListener('click', closeCart);
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // --- ACCORDION ---
  document.querySelectorAll('.accordion-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var content = this.nextElementSibling;
      var isOpen = content && content.classList.contains('open');
      document.querySelectorAll('.accordion-content.open').forEach(function(c) { c.classList.remove('open'); });
      document.querySelectorAll('.accordion-btn').forEach(function(b) {
        var icon = b.querySelector('span:last-child');
        if (icon) icon.textContent = '+';
      });
      if (!isOpen && content) {
        content.classList.add('open');
        var icon = this.querySelector('span:last-child');
        if (icon) icon.textContent = '−';
      }
    });
  });

  // --- SIZE SELECTOR ---
  document.querySelectorAll('.size-btn:not(.soldout)').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
    });
  });

  // --- PRODUCT GALLERY THUMBS ---
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var main = document.querySelector('.product-gallery__main img');
      var img = this.querySelector('img');
      if (main && img) main.src = img.src;
      document.querySelectorAll('.product-gallery__thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // --- NEWSLETTER ---
  document.querySelectorAll('.newsletter-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = this.querySelector('input[type="email"]');
      if (input && input.value) {
        input.value = '';
        input.placeholder = 'Merci pour votre inscription !';
      }
    });
  });

// Menu burger mobile
var burgerBtn = document.getElementById('mobile-menu-btn');
var mobileMenu = document.getElementById('mobile-menu');
var mobileClose = document.getElementById('mobile-menu-close');
if (burgerBtn) burgerBtn.addEventListener('click', function() {
  mobileMenu.classList.add('is-open');
  document.body.style.overflow = 'hidden';
});
if (mobileClose) mobileClose.addEventListener('click', function() {
  mobileMenu.classList.remove('is-open');
  document.body.style.overflow = '';
});

});
